<template>
  <div>
    <div class="bg-white">
      <OtherLoading variant="warning" />
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/other/OtherLoading";
export default {
  components: {
    OtherLoading
  },
  beforeCreate: async function () {
    const queryString = decodeURIComponent(window.location.search);
    const params = new URLSearchParams(queryString);
    const searchParam = params.get("liff.state");
    const valKerryFriend = params.get("isKerryFriend");
    const isKerryFriend = valKerryFriend == "true" ? true : false;
    const sessionId = decodeURIComponent(window.location.search).replace(
      "?sessionId=",
      ""
    );
    this.$liff
      .init({ liffId: isKerryFriend? this.$liff_Main_ID_Kerry_Friend : this.$liff_Main_ID })
      .then(() => {
        if (searchParam) {
          this.$router.push(searchParam);
        } else if (sessionId) {
          this.$router.push(`/login?sessionId=${sessionId}`);
        } else {
          this.$router.push(`/login`);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style lang="scss" scoped>
</style>